import React, { memo } from "react";
import { useGamePage } from "./index.hooks";
import {
  AppSnackbar,
  Board,
  FeedbackDialog,
  GameTimer,
  GameTitle,
  PageWrapper,
  Superpowers,
} from "components";
import { Box, Grid } from "@mui/material";

type GamePageProps = {};

export const GamePage = memo(({}: GamePageProps) => {
  const { isMobile } = useGamePage();

  return (
    <PageWrapper>
      {!isMobile ? (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
          spacing={12}
        >
          <Grid
            container
            item
            md={4}
            direction="column"
            justifyContent="space-between"
          >
            <Grid item sx={{ pl: 6 }}>
              <GameTitle />
            </Grid>
            <Grid container item>
              <Grid item xs={9}>
                <GameTimer />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4}>
            <Board />
          </Grid>
          <Grid container item md={4} justifyContent="start" alignSelf="start">
            <Superpowers />
          </Grid>
          <FeedbackDialog />
        </Grid>
      ) : (
        <Grid container direction="column">
          <Grid item xs={12} sx={{ px: 2 }}>
            <GameTitle />
          </Grid>
          <Grid
            item
            container
            xs={12}
            sx={{
              px: 2,
              my: 3,
            }}
            justifyContent="center"
          >
            <Board />
          </Grid>
          <Grid
            container
            item
            xs={12}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={5}>
              <GameTimer />
            </Grid>
            <Grid item xs={5}>
              <Superpowers />
            </Grid>
          </Grid>
          <FeedbackDialog />
        </Grid>
      )}
    </PageWrapper>
  );
});
